"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenplanImage = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var React = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var styles = _interopRequireWildcard(require("./GenplanImage.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/forbid-elements */

const GenplanImage = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    width,
    height,
    url,
    imageRef,
    isFullscreen
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: styles['genplan-image-container']
  }, /*#__PURE__*/React.createElement("img", {
    src: url,
    className: (0, _clsx.default)(styles['genplan-image'], isFullscreen && styles['fullscreen']),
    ref: imageRef
  }), /*#__PURE__*/React.createElement("svg", {
    id: _constants.SVG_ID,
    viewBox: `0 0 ${width} ${height}`,
    className: styles['genplan']
  }));
});
exports.GenplanImage = GenplanImage;
GenplanImage.displayName = 'GenplanImage';